import { useAuth, ROLE_SI_ADMIN } from '@/contexts/AuthContext';
import { useGuardioes } from './useGuardioes';
import { MuralGuardioes } from './MuralGuardioes';
import { ImportarGuardioes } from './ImportarGuardioes';

export const URL_GUARDIOES = 'https://guardioes-rarolabs.web.app/';

/**
 * Pílula Guardiões (em teste — só o SI entra, ver siPortal.definitions): entrada no treinamento
 * gamificado (app externo), status de quem está logado, mural dos que concluíram com aproveitamento
 * e, pro SI, a importação do CSV. Sem nota e sem ranking (decisão).
 */
export default function GuardioesPage() {
  const { user, userHasRole } = useAuth();
  const { data: guardioes = [], isLoading, guardiaoDe } = useGuardioes();
  const eu = guardiaoDe({ email: user?.email, colaboradorId: user?.collaboratorId });
  const desde = eu?.aprovadoEm?.toDate?.();

  return (
    <div className="space-y-6">
      <div className="grid gap-4 lg:grid-cols-3">
        <div
          data-tour="si-gua-jogar"
          className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-raro-gray-900 via-primary-900 to-primary-700 p-6 text-white shadow-raro lg:col-span-2"
        >
          <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full bg-primary-500/30 blur-2xl" aria-hidden="true" />
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-200">Treinamento gamificado</p>
          <h2 className="mt-2 font-montserrat text-2xl font-bold">Guardiões dos Dados</h2>
          <p className="mt-1 max-w-md text-sm text-primary-100">
            Segurança da Informação, LGPD e uso responsável de IA — em missões curtas. Conclua com 80% ou mais e ganhe o selo de
            Guardião.
          </p>
          <a
            href={URL_GUARDIOES}
            target="_blank"
            rel="noreferrer"
            className="relative mt-5 inline-flex rounded-full bg-white px-5 py-2.5 text-sm font-bold text-primary-800 hover:bg-primary-50"
          >
            Jogar agora ↗
          </a>
        </div>

        <div className="rounded-2xl border border-raro-gray-200 bg-white p-5 shadow-sm" data-tour="si-gua-status">
          <p className="text-xs font-semibold uppercase tracking-wide text-raro-gray-500">Seu status</p>
          {isLoading ? (
            <div className="mt-3 h-14 animate-pulse rounded-xl bg-raro-gray-100" />
          ) : eu ? (
            <div className="mt-3 flex items-center gap-3">
              <span className="grid h-14 w-14 place-items-center rounded-2xl bg-gradient-to-br from-primary-500 to-primary-700 text-2xl text-white shadow-raro">
                🛡️
              </span>
              <div>
                <p className="font-montserrat text-base font-bold text-raro-gray-900">Você é Guardião!</p>
                <p className="text-xs text-raro-gray-500">
                  Concluído com aproveitamento{desde ? ` em ${desde.toLocaleDateString('pt-BR')}` : ''}
                </p>
              </div>
            </div>
          ) : (
            <div className="mt-3 flex items-center gap-3">
              <span className="grid h-14 w-14 place-items-center rounded-2xl border-2 border-dashed border-raro-gray-300 text-2xl text-raro-gray-300">
                🛡️
              </span>
              <div>
                <p className="font-montserrat text-base font-bold text-raro-gray-900">Ainda não concluído</p>
                <p className="text-xs text-raro-gray-500">Jogue e conclua com 80% ou mais para ganhar o selo.</p>
              </div>
            </div>
          )}
          <p className="mt-4 border-t border-dashed border-primary-200 pt-3 text-xs text-raro-gray-500">
            O selo aparece ao lado do seu nome no Digital e vale para sempre.
          </p>
        </div>
      </div>

      <section className="space-y-3" data-tour="si-gua-mural">
        <h2 className="font-montserrat text-base font-semibold text-raro-gray-900">
          Mural dos Guardiões{' '}
          {guardioes.length > 0 && (
            <span className="text-xs font-normal text-raro-gray-500">
              · {guardioes.length} {guardioes.length === 1 ? 'guardião' : 'guardiões'}
            </span>
          )}
        </h2>
        {isLoading ? (
          <div className="h-24 animate-pulse rounded-2xl bg-raro-gray-100" />
        ) : guardioes.length === 0 ? (
          <p className="rounded-2xl border border-dashed border-raro-gray-300 bg-white px-4 py-6 text-center text-sm text-raro-gray-500">
            Ainda ninguém por aqui — seja o primeiro Guardião!
          </p>
        ) : (
          <MuralGuardioes guardioes={guardioes} />
        )}
      </section>

      {userHasRole(ROLE_SI_ADMIN) && (
        <div data-tour="si-gua-importar">
          <ImportarGuardioes jaGuardioes={guardioes} />
        </div>
      )}
    </div>
  );
}
